import styled from 'styled-components';
import { ActionBar } from 'ia-react-core';

export const StyledActionBar = styled(ActionBar)`
  padding-top: 10px;
`;

export const StyledButton = styled.span`
  > button & {
    border-color:  ${({ theme }) => theme.colors.white};
    color:  ${({ theme }) => theme.colors.blue5};

    :hover {
      border-color:  ${({ theme }) => theme.colors.white} !important;
      color:  ${({ theme }) => theme.colors.blue5} !important;
      text-decoration: underline;
    }

    :active {
      color:  ${({ theme }) => theme.colors.blue10} !important;
      text-decoration: underline;
    }
  }
`;
